var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 32.4C28.6392 32.4 32.4 28.6392 32.4 24C32.4 19.3608 28.6392 15.6 24 15.6C19.3608 15.6 15.6 19.3608 15.6 24C15.6 28.6392 19.3608 32.4 24 32.4ZM24 34C29.5228 34 34 29.5228 34 24C34 18.4772 29.5228 14 24 14C18.4772 14 14 18.4772 14 24C14 29.5228 18.4772 34 24 34Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 29.4C26.9823 29.4 29.4 26.9823 29.4 24C29.4 21.0177 26.9823 18.6 24 18.6C21.0177 18.6 18.6 21.0177 18.6 24C18.6 26.9823 21.0177 29.4 24 29.4ZM24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9345 17.4343C17.2469 17.1219 17.7535 17.1219 18.0659 17.4343L19.5659 18.9343C19.8783 19.2467 19.8783 19.7533 19.5659 20.0657C19.2535 20.3781 18.7469 20.3781 18.4345 20.0657L16.9345 18.5657C16.6221 18.2533 16.6221 17.7467 16.9345 17.4343ZM28.4345 27.4343C28.7469 27.1219 29.2535 27.1219 29.5659 27.4343L31.5659 29.4343C31.8783 29.7467 31.8783 30.2533 31.5659 30.5657C31.2535 30.8781 30.7469 30.8781 30.4345 30.5657L28.4345 28.5657C28.1221 28.2533 28.1221 27.7467 28.4345 27.4343Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8155 16.6843C31.1279 16.9967 31.1279 17.5033 30.8155 17.8157L29.0655 19.5657C28.7531 19.8781 28.2465 19.8781 27.9341 19.5657C27.6217 19.2533 27.6217 18.7467 27.9341 18.4343L29.6841 16.6843C29.9965 16.3719 30.5031 16.3719 30.8155 16.6843ZM20.5655 28.4343C20.8779 28.7467 20.8779 29.2533 20.5655 29.5657L18.8155 31.3157C18.5031 31.6281 17.9965 31.6281 17.6841 31.3157C17.3717 31.0033 17.3717 30.4967 17.6841 30.1843L19.4341 28.4343C19.7465 28.1219 20.2531 28.1219 20.5655 28.4343Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink1);
export default __webpack_public_path__ + "static/media/icon-link1.e3c479c1207a59d2bf34db94dbec9595.svg";
export { ForwardRef as ReactComponent };